import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';

interface ICommentEditInput {
  onSubmit: (content: string) => void;
  initValue: string;
  onCancel: () => void;
}

const CommentEditInput = ({
  onSubmit,
  onCancel,
  initValue,
}: ICommentEditInput) => {
  const { TextArea } = Input;
  const [value, setValue] = useState('');

  useEffect(() => setValue(initValue), [initValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };
  const handleSubmitButton = () => {
    setValue('');
    onSubmit(value);
  };
  return (
    <div>
      <TextArea value={value} rows={4} onChange={handleInputChange} />
      <Button onClick={onCancel}>Huỷ</Button>
      <Button onClick={handleSubmitButton}>Cập nhật</Button>
    </div>
  );
};

export default CommentEditInput;
